export default {
  VERTICAL: {
    'ALCOHOL': 'Alcohol',
    'APPAREL': 'Ropa y vestimenta',
    'AUTO': 'Automotriz',
    'BEAUTY': 'Belleza, spa y salón',
    'EDU': 'Educación',
    'ENTERTAIN': 'Entretenimiento',
    'EVENT_PLAN': 'Servicio y planificación de eventos',
    'FINANCE': 'Finanzas y banca',
    'GOVT': 'Servicio público',
    'GROCERY': 'Alimentos y abarrotes',
    'HEALTH': 'Médico y salud',
    'HOTEL': 'Hotel y alojamiento',
    'MATRIMONY_SERVICE': 'Servicios de matrimonio',
    'NONPROFIT': 'Sin fines de lucro',
    'ONLINE_GAMBLING': 'Juegos de azar en línea',
    'OTC_DRUGS': 'Medicamentos de venta libre',
    'OTHER': 'Otro',
    'PHYSICAL_GAMBLING': 'Juegos de azar',
    'PROF_SERVICES': 'Servicio profesional',
    'RESTAURANT': 'Restaurante',
    'RETAIL': 'Compras y ventas al por menor',
    'TRAVEL': 'Viajes y transporte',
  }
};